import Toast from "@components/Toast";
import {countNormalImagesFromHtml, MAX_THREAD_IMAGES} from '@utils/setPostLimits';
import {uploadAttachment} from "@server";

/**
 * 上传图片文件
 */
const updateImageFile = async (type, image) => {
    // 上传图片
    const formData = new FormData();
    formData.append('type', '1'); // 1 = 图片
    if (type === 'image') {
      formData.append('fileUrl', image.src);
    } else {
      formData.append('file', image);
    }
    const closeLoading = Toast.loading({
        content: '图片上传中，请稍候...',
        duration: 0,
    });
    return await uploadAttachment(formData)
        .finally(closeLoading)
        .then(response => {
            const imageData = response.data as { url?: string; webpUrl?: string } | undefined;
            const imageUrl = imageData?.webpUrl || imageData?.url;
            if (response.code === 0 && imageUrl) {
                if (type === 'image') {
                  image.src = imageUrl
                  return true;
                }
                return imageUrl;
            } else {
                Toast.error(response.message || '图片上传失败');
                image.remove();
                return false;
            }
        })
        .catch(error => {
            console.error('[TiptapEditor] 粘贴图片上传失败:', error);
            Toast.error('图片上传失败');
            image.remove();
            return false;
        });
}

const handleImage = async (div, callback, remainingSlots) => {
    // 获取剪切板里的图片
    let images = div.getElementsByTagName('IMG');
    if (images.length) {
        // 显示上传中状态
        callback('image', true);
        for (let f = 0; f < images.length; f++) {
            if (remainingSlots > 0) {
                // 上传图片
                await updateImageFile('image', images[f])
            } else {
                images[f].remove()
            }
            remainingSlots--;
        }
        // 关闭上传中状态
        callback('image', false);
        if (remainingSlots < 0) {
            Toast.error(`图文内容最多上传 ${MAX_THREAD_IMAGES} 张图片`);
        }
    }
}

const handleLink = async (div, callback) => {
    // 获取剪切板里的A
    let as = div.getElementsByTagName('A');
    if (as.length) {
        for (let a = 0; a < as.length; a++) {
            if (!callback('link', as[a].href)) {
                as[a].href = 'javascript:;'
            }
        }
    }
}

/**
 *  获取内容类型
 */
export const getContentType = types => {
    let typeStr = types.join('-')
    if (typeStr.indexOf('Files') !== -1) {
        return 'file';
    } else if (typeStr.indexOf('text/html') !== -1) {
        return 'html';
    } else if (typeStr.indexOf('text/plain') !== -1) {
        return 'text';
    }
    return ``;
}

/**
 * 编辑器复制内容处理
 */
export const pasteContent = async (event, editor, content, callback) => {
    const clipboardData = event.clipboardData
    if ( clipboardData.items ) {
        // 拦截默认行为
        event.preventDefault();
        // 获取视图内容
        const viewHtml = editor.getHTML() || content || ''
        // 当前图片总数
        let currentImageCount = countNormalImagesFromHtml(viewHtml);
        // 剩余上传数量
        let remainingSlots = MAX_THREAD_IMAGES - currentImageCount;

        // 获取剪切板内容
        let items = clipboardData.items;
        for (let i = 0; i < items.length; i++) {
            let item = items[i]
            if (item.type.indexOf('html') !== -1) {
                item.getAsString(async (content) => {
                    // 创建一个元素放剪切板内容
                    let div = document.createElement('div');
                    div.innerHTML = content;
                    // 处理图片
                    await handleImage(div, callback, remainingSlots);
                    // 处理链接
                    await handleLink(div, callback)
                    // 去除剪切板中无用的内容
                    div.innerHTML = div.innerHTML.replace('<!--StartFragment-->', '')
                    div.innerHTML = div.innerHTML.replace('<!--EndFragment-->', ' ')
                    // 添加内容到编辑器中
                    editor.chain().focus().insertContent(div.innerHTML).run();
                })
            } else if (item.type.indexOf('image') !== -1) {
                if (remainingSlots > 0) {
                    // 显示上传中状态
                    callback('image', true);
                    // 上传图片
                    let url = await updateImageFile('file', item.getAsFile())
                    // 关闭上传中状态
                    callback('image', false);
                    // 添加内容到编辑器中
                    editor.chain().focus().insertContent(`<img src="${url}">`).run();
                } else {
                    Toast.error(`图文内容最多上传 ${MAX_THREAD_IMAGES} 张图片`);
                }
                remainingSlots--;
            }
        }
    }
};
